import { render, staticRenderFns } from "./PillsRandom.vue?vue&type=template&id=6e03f2b2&"
import script from "./PillsRandom.vue?vue&type=script&lang=js&"
export * from "./PillsRandom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports